var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.4736 20 20 15.4736 20 10C20 4.51645 15.4736 0 9.99003 0C4.51645 0 0 4.51645 0 10C0 15.4736 4.52642 20 10 20ZM10 11.8245C9.6012 11.8245 9.36191 11.5852 9.36191 11.1565L9.25224 5.71286C9.24227 5.29412 9.55135 4.98504 9.99003 4.98504C10.4387 4.98504 10.7478 5.29412 10.7478 5.72283L10.6281 11.1565C10.6181 11.5852 10.3888 11.8245 10 11.8245ZM10 14.985C9.49153 14.985 9.05284 14.5663 9.05284 14.0578C9.05284 13.5593 9.48155 13.1406 10 13.1406C10.5184 13.1406 10.9571 13.5494 10.9571 14.0578C10.9571 14.5663 10.5184 14.985 10 14.985Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.71ad959bb165decb4decf201c88ce717.svg";
export { ForwardRef as ReactComponent };